import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';

const getArrowSVG = (fillColor) => {
  const svgContent = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="46" viewBox="0 0 22 46" fill="none">
      <g clip-path="url(#clip0_32548_137886)">
      <g filter="url(#filter0_d_32548_137886)">
      <path d="M10 23L0 46V0L10 23Z" fill="${fillColor}"/>
      </g>
      </g>
      <defs>
      <filter id="filter0_d_32548_137886" x="-8" y="-10" width="30" height="66" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="2"/>
      <feGaussianBlur stdDeviation="5"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_32548_137886"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_32548_137886" result="shape"/>
      </filter>
      <clipPath id="clip0_32548_137886">
      <rect width="22" height="46" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  `;

  return `data:image/svg+xml,${encodeURIComponent(svgContent)}`;
};

export const NavigationStepperStepWrapper = styled.li<{ isActive: boolean; isCompleted: boolean }>`
  height: 46px;
  min-width: 30px;
  max-width: 100%;
  ${flex({ alignItems: 'center' })};
  flex-wrap: nowrap;
  padding-left: 34px;
  padding-right: 18px;
  position: relative;
  background-color: ${({ isActive, isCompleted }) =>
    isActive ? COLORS.green[300] : isCompleted ? COLORS.grey[300] : COLORS.grey[200]};

  &:first-child {
    padding-left: 16px;
    border-bottom-left-radius: 6px;
    border-top-left-radius: 6px;
  }
`;

export const Arrows = styled.span<{ isActive: boolean; isCompleted: boolean }>`
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    right: -21px;
    width: 22px;
    height: 46px;
    background-image: url('${({ isActive, isCompleted }) => {
      if (isActive) return getArrowSVG(COLORS.green[300]);
      if (isCompleted) return getArrowSVG(COLORS.grey[300]);

      return getArrowSVG(COLORS.grey[200]);
    }}');
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 2;
  }
`;
